"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Blacklist = exports.Whitelist = void 0;
require("reflect-metadata");
const constants_1 = require("../constants");
function createDecorator(metadataKey, options) {
    return (target, propertyKey) => {
        if (propertyKey) {
            options.query ??= [];
            options.read ??= [];
            options.search ??= [];
            Reflect.defineMetadata(metadataKey, options, target, propertyKey);
            const existing = Reflect.getMetadata(metadataKey, target) ?? [];
            if (!existing.includes(propertyKey)) {
                Reflect.defineMetadata(metadataKey, [...existing, propertyKey], target);
            }
        }
    };
}
const Whitelist = (options = {}) => createDecorator(constants_1.MetaDatas.WHITELIST_MODEL, options);
exports.Whitelist = Whitelist;
const Blacklist = (options = {}) => createDecorator(constants_1.MetaDatas.BLACKLIST_MODEL, options);
exports.Blacklist = Blacklist;
